import { Injectable } from '@angular/core';
import { IConfiguracionImpresora } from '@core/interfaces/entidades/configuracion-impresora.entidad';
import { ApiResponseDefault } from '@core/interfaces/request-response/api.dto';
import {
  ICrearImpresoraRq,
  CreatePrintJobRq,
} from '@core/interfaces/request-response/impresora.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';
import { logger } from '@shared/utils/functions.utils';

@Injectable({
  providedIn: 'root',
})
export class ImpresoraApiService extends BaseHttpService {
  cargarImpresoras() {
    return this.httpClient.get<IConfiguracionImpresora[]>(
      `${environment.apiUrl}${environment.apiPreFix}/impresora/cargar`,
    );
  }
  guardarConfigImpresora(rq: ICrearImpresoraRq) {
    return this.withLoader(
      this.httpClient.post<IConfiguracionImpresora>(
        `${environment.apiUrl}${environment.apiPreFix}/impresora/crear-guardar`,
        rq,
      ),
    );
  }
  eliminarConfigImpresora(configId: number) {
    return this.withLoader(
      this.httpClient.delete(
        `${environment.apiUrl}${environment.apiPreFix}/impresora/eliminar/${configId}`,
      ),
    );
  }
  imprimir(rq: CreatePrintJobRq) {
    logger('Enviando solicitud de impresión:', rq);
    return this.withLoader(
      this.httpClient.post<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/impresora/crear-print-job`,
        rq,
      ),
    );
  }
}
